import { ContractError } from './contracts';
import { parseReferrals, type Referral } from './referralContracts';

export type ReferralLogEntry = Referral &
  Readonly<{
    referrerPlayerId: number;
    referrerUsername: string;
    usedAtMs: number | null;
  }>;
export type ReferralLogPage = Readonly<{
  referrals: readonly ReferralLogEntry[];
  hasMore: boolean;
  nextBeforeId: number;
  requiredLevel: number;
  rewardCoins: number;
}>;
export type ReferralLogGateway = (
  query: string,
  status: string,
  beforeId: number,
  signal: AbortSignal,
) => Promise<ReferralLogPage>;

export function parseReferralLog(value: unknown): ReferralLogPage {
  const base = parseReferrals(value);
  const body = value as Record<string, unknown>;
  const invalid = (): never => {
    throw new ContractError('Invalid referral log response.');
  };
  const positiveInteger = (value: unknown): number => {
    if (typeof value !== 'number' || !Number.isSafeInteger(value) || value < 1) return invalid();
    return value;
  };
  const requiredLevel = positiveInteger(body.requiredLevel);
  const rewardCoins = positiveInteger(body.rewardCoins);
  const raw = body.referrals as Record<string, unknown>[];
  const referrals = base.referrals.map((entry, index): ReferralLogEntry => {
    const row = raw[index];
    if (
      !row ||
      typeof row.referrerUsername !== 'string' ||
      (row.usedAtMs !== null &&
        (typeof row.usedAtMs !== 'number' ||
          !Number.isSafeInteger(row.usedAtMs) ||
          row.usedAtMs < 0 ||
          row.usedAtMs > 8.64e15))
    )
      return invalid();
    const referrerPlayerId = positiveInteger(row.referrerPlayerId);
    if (referrerPlayerId === entry.playerId) return invalid();
    return {
      ...entry,
      referrerPlayerId,
      referrerUsername: row.referrerUsername,
      usedAtMs: row.usedAtMs,
    };
  });
  return { ...base, referrals, requiredLevel, rewardCoins };
}
